module.exports = __webpack_public_path__ + "img/play.0f7aa86c.svg";